import {ChangeDetectorRef, Injectable, TemplateRef, ViewContainerRef} from "@angular/core";
import {BehaviorSubject} from "rxjs";

export type ComponentsList = Map<number | string, {component: TemplateRef<any>, payload: any }>;

@Injectable()
export class PortalSlotService {

  components$: BehaviorSubject<ComponentsList> = new BehaviorSubject<ComponentsList>(new Map());

  private container = new BehaviorSubject<ViewContainerRef | null>(null);

  constructor(private cdr: ChangeDetectorRef) {}

  set containerRef(container: ViewContainerRef | null) {
    this.container.next(container);
  }
  private setCurrentMapOnStream(): void {
    this.components$.next(this.components$.value);
  }

  addTemplateComponent<T, P>(component: TemplateRef<T>, key: string | number, payload?: P): void {
    if(this.container.value && !this.components$.value.has(key)) {
      this.components$.value.set(key, {component, payload});
      this.setCurrentMapOnStream();
      this.cdr.detectChanges();
    }
  }

  removeTemplateComponent(key: number | string): void {
    this.components$.value.delete(key)
    this.setCurrentMapOnStream();
  }
}
